import React from 'react';
import './VersionDropContainer.css';
import { getTranslation } from '../../assets/creator/translations';
import Select from 'react-select';
import {versionRedirect, getCurrentVersion} from './Helpers/VersionRedirect';
import {getCreatorAddresses} from './Helpers/creatorAddresses';

const VersionDropContainer = () => (
    <div className="version-drop-container version-drop-container--hidden">
        <p>{getTranslation("R_ChooseVersion")}</p>
        <Select 
            className="version-drop-container__select"
            placeholder={""}
            options={getCreatorAddresses(getTranslation)}
            onChange={versionRedirect}
            closeMenuOnSelect={true}
            closeMenuOnScroll={true}
            hideSelectedOptions={true}
            value={getCurrentVersion()}
        />
    </div>
)

export default VersionDropContainer;